<template>
  <div>
    <div>
      <div class="breadcrumb">
        <h1 style="color: #AC8400;">My Activity</h1>
      </div>
      <!-- Breadcrumbs -->
      <div style="padding: 10px; background-color: #F2F2F2">
        <router-link to="/dashboard">Dashboard </router-link>/
        <router-link to="/marketing">
          Marketing
        </router-link>
        /
        <router-link to="/marketing/my-activity">
          My Activity
        </router-link>
        /
        <b>Details</b>
      </div>
      <div class="separator-breadcrumb border-top"></div>

      <!-- End of breadcrumbs -->
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="home-basic-tab" data-toggle="tab" href="#_active" role="tab"
            aria-controls="_active" aria-selected="true">Details</a>
        </li>
        <li v-if="data.type_id === 2" class="nav-item">
          <a class="nav-link" id="profile-basic-tab" data-toggle="tab" href="#_inactive" role="tab"
            aria-controls="_inactive" aria-selected="false">Feedback</a>
        </li>
      </ul>

      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active bg-white position-relative" id="_active" role="tabpanel"
          aria-labelledby="individual-tab">
          <form id="detail-form" ref="detailForm" class="container-fluid needs-validation" @submit.prevent="openModal">
            <div class="mb-3">
              <!-- Radio Buttons -->
              <div class="d-flex flex-wrap">
                <div class="form-check form-check-inline mb-2 me-4 custom-radio">
                  <input v-model="data.type_id" :value="2" type="radio" id="rsvp" name="type" class="form-check-input"
                    required :disabled="isDisabled || data.type_id === 3 || data.type_id === 4
                      " @change="handleType" />
                  <label for="rsvp" class="form-check-label">RSVP</label>
                </div>
                <div class="form-check form-check-inline mb-2 me-4">
                  <input v-model="data.type_id" :value="3" type="radio" id="request-tba" name="type"
                    class="form-check-input" required :disabled="isDisabled || data.type_id === 2"
                    @change="handleType" />
                  <label for="request-tba" class="form-check-label">Request for Call (TBA)</label>
                </div>
                <div class="form-check form-check-inline mb-2">
                  <input v-model="data.type_id" :value="4" type="radio" id="request-tbk" name="type"
                    class="form-check-input" required :disabled="isDisabled || data.type_id === 2"
                    @change="handleType" />
                  <label for="request-tbk" class="form-check-label">Request for Call (TBK)</label>
                </div>
              </div>
              <div v-if="errors.type">
                <small class="text-danger">{{ errors.type }}</small>
              </div>
            </div>

            <!-- Title -->
            <div class="mb-3">
              <label for="title" class="form-label">Title</label>
              <input v-model="data.title" type="text" id="title" class="form-control" placeholder="My Activity Title..."
                required :disabled="isDisabled" />
              <div v-if="errors.title">
                <small class="text-danger">{{ errors.title }}</small>
              </div>
            </div>

            <!-- Short Description -->
            <div class="mb-3">
              <label for="short-description" class="form-label">Short Description</label>
              <input v-model="data.short_description" type="text" id="short-description" class="form-control"
                placeholder="Enter short description" required :disabled="isDisabled" />
              <div v-if="errors.short_description">
                <small class="text-danger">{{
                  errors.short_description
                  }}</small>
              </div>
            </div>

            <!-- Long Description -->
            <div class="mb-3">
              <label for="long-description" class="form-label">Long Description</label>
              <textarea v-model="data.long_description" id="long-description" class="form-control"
                placeholder="Enter long description" rows="4" required :disabled="isDisabled"></textarea>
              <div v-if="errors.long_description">
                <small class="text-danger">{{ errors.long_description }}</small>
              </div>
            </div>
            <div class="d-flex flex-column mb-3 " v-if="data.type_id === 3 || data.type_id === 4">
              <label for="product_id" class="block">Product</label>
              <select id="product_id" v-model="data.product_id" class="border p-2 rounded w-full mt-1 bg-gray-100"
                :disabled="isDisabled">
                <option v-for="product in data.type_id === 3
                  ? tba_products
                  : tbk_products" :key="product.id" :value="product.id">{{ product.name }}</option>
              </select>

              <div v-if="errors.field1">
                <small class="text-danger">{{ errors.field1 }}</small>
              </div>
            </div>
            <div v-if="data.type_id === 2" class="mb-3">
              <div class="row g-2">
                <!-- Venue Input -->
                <div class="col-md-6">
                  <label for="venue" class="form-label">Venue</label>
                  <input v-model="data.venue" type="text" id="venue" class="form-control" placeholder="Enter Venue..."
                    required :disabled="isDisabled" />
                  <div v-if="errors.venue">
                    <small class="text-danger">{{ errors.venue }}</small>
                  </div>
                </div>

                <!-- Date Input -->
                <div class="col-md-3">
                  <label for="venue-date" class="form-label">Date</label>
                  <input v-model="unformattedDate" type="date" id="venue-date" class="form-control"
                    placeholder="dd/mm/yyyy" required :disabled="isDisabled" />
                  <div v-if="errors.unformattedDate">
                    <small class="text-danger">{{
                      errors.unformattedDate
                      }}</small>
                  </div>
                </div>

                <!-- Time Input -->
                <div class="col-md-3">
                  <label for="venue-time" class="form-label">Time</label>
                  <input v-model="unformattedTime" type="time" id="venue-time" class="form-control" placeholder="--:--"
                    required :disabled="isDisabled" />
                  <div v-if="errors.time">
                    <small class="text-danger">{{ errors.time }}</small>
                  </div>
                </div>
              </div>
            </div>

            <!-- Success Message -->
            <div class="mb-3">
              <label for="success-message" class="form-label">Success Message</label>
              <input v-model="data.success_message" type="text" id="success-message" class="form-control"
                placeholder="Enter success messages..." required :disabled="isDisabled" />
              <div v-if="errors.success_message">
                <small class="text-danger">{{ errors.success_message }}</small>
              </div>
            </div>

            <!-- Decline Message -->
            <div class="mb-3" v-if="data.type_id === 2">
              <label for="decline-message" class="form-label">Decline Message</label>
              <input v-model="data.decline_message" type="text" id="decline-message" class="form-control"
                placeholder="Enter decline messages..." required :disabled="isDisabled" />
              <div v-if="errors.decline_message">
                <small class="text-danger">{{ errors.decline_message }}</small>
              </div>
            </div>

            <!-- Upload Image Link -->
            <!-- <div class="mb-3">
              <label for="upload-image" class="form-label">Upload Image Link</label>
              <input type="file" id="upload-image" class="form-control" @change="handleFileUpload" required>
              <div v-if="errors.image_upload">
                <small class="text-danger">{{ errors.image_upload }}</small>
              </div>
            </div> -->

            <div class="mb-3">
              <label for="upload-image" class="form-label">Upload Image <span class="text-danger small">* Recommended
                  image
                  upload size 600px x 600px</span></label>
              <input type="file" ref="file" id="upload-image" class="form-control" v-on:change="handleFileUpload"
                :disabled="isDisabled" />
              <div v-if="errors.image_upload">
                <small class="text-danger">{{ errors.image_upload }}</small>
              </div>
            </div>

            <ConditionSelect v-for="(condition, index) in data.conditions" :key="index" :index="index" :errors="errors"
              @condition-change="onConditionChange" @disabled="handleDisabled" @value-change="onValueChange"
              @clear-error="clearError" :condition="data.conditions[index]" :conditionOptions="conditionOptions"
              :isDisabled="isDisabled" :label="index === 0
                  ? 'Condition 1 (required)'
                  : index === 1
                    ? 'Condition 2 (optional)'
                    : ''
                " />

            <div class="mb-3" v-if="data.type_id === 2">
              <label for="quota" class="form-label">Set Quota</label>
              <div class="d-flex align-items-center">
                <input v-model="data.quota" type="number" id="quota" class="form-control me-2 text-right"
                  style="width: 150px;" placeholder="" required :disabled="isDisabled" />
              </div>
              <div v-if="errors.quota">
                <small class="text-danger">{{ errors.quota }}</small>
              </div>
            </div>

            <div class="row g-2">
              <!-- Start Date -->
              <div class="mb-3 col-md-4">
                <label for="start_at" class="form-label">Start Date</label>
                <input type="date" v-model="data.start_at" id="start_at" class="form-control" placeholder="dd/mm/yyyy"
                  required :disabled="isDisabled" />
                <div v-if="errors.start_at">
                  <small class="text-danger">{{ errors.start_at }}</small>
                </div>
              </div>

              <!-- End Date -->
              <div class="mb-3 col-md-4">
                <label for="end-date" class="form-label">End Date</label>
                <input type="date" v-model="data.end_at" id="end-date" class="form-control" placeholder="dd/mm/yyyy"
                  required :disabled="isDisabled" />
                <div v-if="errors.end_at">
                  <small class="text-danger">{{ errors.end_at }}</small>
                </div>
              </div>

              <!-- Notification time  -->
              <div class="mb-3 col-md-4">
                <label for="notif-time" class="form-label">Notification Time</label>
                <input type="time" id="notif-time" v-model="data.notification_time" class="form-control"
                  placeholder="--/--" required :disabled="isDisabled" />
                <div v-if="errors.notification_time">
                  <small class="text-danger">{{
                    errors.notification_time
                    }}</small>
                </div>
              </div>
            </div>
            <!-- Submit Button -->
            <button type="submit" class="btn btn-primary" :disabled="isDisabled">
              Submit
            </button>
          </form>
          <div style="position: absolute; top: 0; right: 0;">
            <div class="d-flex flex-column">
              <button v-if="data.type_id == 2" :class="data.cancelled_at !== null
                  ? 'btn btn-secondary'
                  : 'btn btn-danger'
                " :disabled="data.cancelled_at !== null" @click="openCancelModal">
                {{ data.cancelled_at !== null ? "Cancelled" : "Cancel Event" }}
              </button>
              <small class="mt-1">{{
                data.cancelled_at !== null
                  ? "Cancelled at " + data.cancelled_at
                  : ""
              }}</small>
            </div>
          </div>

          <div>
            <hr />
            <ul class="nav nav-tabs" id="myTab2" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" id="home-basic-tab2" data-toggle="tab" href="#_RSVP" role="tab"
                  aria-controls="_RSVP" aria-selected="true">{{ data.type_id == 2 ? "RSVP" : "Request" }}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="profile-basic-tab2" data-toggle="tab" href="#_logs" role="tab"
                  aria-controls="_logs" aria-selected="false">Logs</a>
              </li>
            </ul>

            <!-- request/rsvp tab -->
            <div class="tab-content">
              <div class="tab-pane fade show active bg-white" id="_RSVP" role="tabpanel"
                aria-labelledby="home-basic-tab2">
                <div v-if="data.type_id === 2" class="p-2 mb-2" style="background-color: #F2F2F2;">
                  <h5>Summary Report</h5>
                  <ul>
                    <li>RSVP - {{ summary.rsvp }}</li>
                    <li>Decline - {{ summary.decline }}</li>
                  </ul>
                </div>

                <div v-if="data.type_id === 2" class="mt-3">
                  <TableComponent :id="'rsvp_tbl'" title="RSVP" :headers="[
                    'No.',
                    'RSVP Date',
                    'IC Number',
                    'Customer Name',
                    'Mobile Number'
                  ]" :data="rsvp" :fields="[
                      'index',
                      'rsvp_at',
                      'user.ic_number',
                      'user.name',
                      'user.mobile_number'
                    ]">
                  </TableComponent>
                </div>

                <div v-if="data.type_id === 4" class="mt-3">
                  <TableComponent :id="'tbk_tbl'" title="Request for Call (TBK)" :headers="[
                    'No.',
                    'Date',
                    'IC Number',
                    'Customer Name',
                    'Mobile Number'
                  ]" :data="call_requests" :fields="[
                      'index',
                      'created_at',
                      'mobile_number',
                      'customer_name',
                      'customer_ic'
                    ]">
                  </TableComponent>
                </div>

                <div v-if="data.type_id === 3" class="mt-3">
                  <TableComponent :id="'tba_tbl'" title="Request for Call (TBA)" :headers="[
                    'No.',
                    'Date',
                    'IC Number',
                    'Customer Name',
                    'Mobile Number'
                  ]" :data="call_requests" :fields="[
                      'index',
                      'created_at',
                      'mobile_number',
                      'customer_name',
                      'customer_ic'
                    ]">
                  </TableComponent>
                </div>
                <div v-if="data.type_id === 2" class="mt-3">
                  <TableComponent :id="'declined_tbl'" title="Declined" :headers="[
                    'No.',
                    'RSVP Date',
                    'Decline Date',
                    'IC Number',
                    'Customer Name',
                    'Mobile Number',
                    'Reason'
                  ]" :data="declined" :fields="[
                      'index',
                      'rsvp_at',
                      'declined_at',
                      'user.ic_number',
                      'user.name',
                      'user.mobile_number',
                      'remarks'
                    ]">
                  </TableComponent>
                </div>
              </div>
              <!-- logs tab -->
              <div class="tab-pane fade bg-white" id="_logs" role="tabpanel" aria-labelledby="profile-basic-tab2">
                <div class="mt-4 mb-4" v-if="data.type_id === 2">
                  <TableComponent :id="'declined_rsvp_tbl'" title="RSVP/Declined" :headers="[
                    { label: 'No.', width: '5%' },
                    { label: 'RSVP/Decline Date', width: '25%' },
                    { label: 'IC Number', width: '15%' },
                    { label: 'Customer Name', width: '20%' },
                    { label: 'Mobile No.', width: '15%' },
                    { label: 'Type', width: '10%' }
                  ]" :data="processedRsvpDecline" :fields="[
                      'index',
                      'rsvp_decline_date',
                      'ic_number',
                      'customer_name',
                      'mobile_number',
                      'type'
                    ]" />
                </div>
                <div class="mt-4 mb-4">
                  <TableComponent :id="'event_log_tbl'" title="Event Update Logs" :headers="[
                    { label: 'No.', width: '5%' },
                    { label: 'Event Update Date', width: '30%' },
                    { label: 'Admin', width: '25%' },
                    { label: 'Change', width: '40%' }
                  ]" :data="eventLog" :fields="['index', 'event_update_date', 'admin', 'change']" />
                </div>
                <div>
                  <h5>More Info Logs</h5>
                  <div class="mb-3 row">
                    <label for="date" class="col-sm-1 col-form-label">Select Date</label>
                    <div class="col-sm-2">
                      <input type="date" v-model="filteredDate" v-on:change="filterDate" id="filtered_date"
                        class="form-control" placeholder="mm/dd/yyyy" required />
                    </div>
                  </div>

                  <!-- <TableComponent id="more_info_tbl" title="" :headers="[
                    'No.',
                    'More info Date',
                    'IC Number',
                    'Customer Name',
                    'Mobile No.',

                  ]" :data="moreInfoLogs"
                    :fields="['index', 'user_my_activities.user_clicked_at', 'ic_number', 'name', 'mobile_number']">
                  </TableComponent> -->
                  <div class="table-responsive">
                    <table id="more_info_tbl" class="display table table-striped table-bordered"
                      style="width:100%; text-align: center;">
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>More info Date</th>
                          <th>IC Number</th>
                          <th>Customer Name</th>
                          <th>Mobile No.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in moreInfoLogs" :key="item.id">
                          <td>{{ index + 1 }}</td>
                          <td>
                            {{
                              item.user_my_activities.length > 0
                                ? item.user_my_activities[0].user_clicked_at
                                : "-"
                            }}
                          </td>
                          <td>{{ item.ic_number || "-" }}</td>
                          <td>{{ item.name || "-" }}</td>
                          <td>{{ item.mobile_number || "-" }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Feedback @feedback="openFeedbackModal" @editData="openEditFeedbackModal" :editOnly="this.editOnly"
          :my_activity_id="Number(this.$route.params.id)" :data="feedbacksQuestion" :update="handleFeedbackSubmit"
          :isDisabled="isDisabled" />
      </div>
    </div>
    <div class="modal fade" :class="{ show: isModalVisible }" tabindex="-1" role="dialog"
      style="display: block;background-color: rgba(0, 0, 0, 0.5);" v-if="isModalVisible" @click.self="closeModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header justify-content-center">
            <h5 class="modal-title text-primary text-center">Message</h5>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <label for="">Message to notify users</label>
            <textarea v-model="message" id="message" type="text" ref="modalInput" class="form-control"
              placeholder=""></textarea>
            <div v-if="errors.message">
              <small class="text-danger">{{ errors.message }}</small>
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer justify-content-center">
            <button type="button" class="btn border-primary text-primary" @click="closeModal">
              Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="handleSubmit">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" :class="{ show: cancelModal }" tabindex="-1" role="dialog"
      style="display: block;background-color: rgba(0, 0, 0, 0.5);" v-if="cancelModal" @click.self="cancelModal = false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header justify-content-center">
            <h5 class="modal-title text-primary text-center">Message</h5>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <label for="">Message to notify users</label>
            <textarea v-model="cancelMessage" id="message" type="text" ref="modalInput" class="form-control"
              placeholder=""></textarea>
            <div v-if="cancelErrorMessage">
              <small class="text-danger">{{ cancelErrorMessage }}</small>
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer justify-content-center">
            <button type="button" class="btn border-primary text-primary" @click="cancelModal = false">
              Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="handleCancel">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Feedback Modal -->
    <div class="modal fade" :class="{ show: feedbackModal }" tabindex="-1" role="dialog"
      style="display: block;background-color: rgba(0, 0, 0, 0.5);" v-if="feedbackModal" @click.self="closeModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body d-flex flex-column align-items-center text-center">
            <h4 class="text-primary">
              Are you sure you want to publish the questions?
            </h4>
            <p>Once published, the questions cannot be added or deleted.</p>
            <div>
              <button type="button" class="btn border-primary text-primary me-2 mr-2" @click="feedbackModal = false">
                Cancel
              </button>
              <button type="button" class="btn btn-primary" @click="handleFeedbackSubmit">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Question Modal -->
    <div class="modal fade" :class="{ show: editQuestionModal }" tabindex="-1" role="dialog"
      style="display: block;background-color: rgba(0, 0, 0, 0.5);" v-if="editQuestionModal"
      @click.self="editQuestionModal = false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body d-flex flex-column ">
            <h4 class="text-primary">
              Edit Question
            </h4>
            <div class="">
              <div class="flex-shrink-0" style="flex: 1 1 25%;">
                <label :for="'type-' + index" class="form-label">Type</label>
                <div class="d-flex flex-wrap">
                  <div class="form-check form-check-inline mb-2 me-4">
                    <input :disabled="true" v-model="question.type" :value="1" type="radio" :id="'rsvp-' + index"
                      :name="'type-' + index" class="form-check-input" required />
                    <label :for="'rsvp-' + index" class="form-check-label">Rating</label>
                  </div>
                  <div class="form-check form-check-inline mb-2 me-4">
                    <input :disabled="true" v-model="question.type" :value="2" type="radio" :id="'request-tba-' + index"
                      :name="'type-' + index" class="form-check-input" required />
                    <label :for="'request-tba-' + index" class="form-check-label">Yes or No</label>
                  </div>
                  <div class="form-check form-check-inline mb-2">
                    <input :disabled="true" v-model="question.type" :value="3" type="radio" :id="'request-tbk-' + index"
                      :name="'type-' + index" class="form-check-input" required />
                    <label :for="'request-tbk-' + index" class="form-check-label">Open Text</label>
                  </div>
                </div>
              </div>
              <div style="flex: 1 1 75%;">
                <label :for="'question-' + index" class="form-label">Question</label>
                <div class="d-flex justify-content-center align-items-center">
                  <input v-model="question.question" type="text" :id="'question-' + index" class="form-control me-2 "
                    placeholder="Enter a question..." required />
                  <div class="invalid-feedback">Please provide a question.</div>
                </div>
              </div>
            </div>

            <div class="mt-3 align-items-center text-center">
              <button type="button" class="btn border-primary text-primary me-2 mr-2"
                @click="editQuestionModal = false">
                Cancel
              </button>
              <button type="button" class="btn btn-primary" @click="handleFeedbackUpdate(question.id)">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import TableComponent from "./table.vue";
import { ref } from "vue";
import {
  cancelMyActivity,
  getFeedback,
  getLog,
  getMoreInfo,
  storeFeedback,
  updateFeedback,
  updateMyActivity,
  viewMyActivity
} from "../../../services/MyActivityService";
import ConditionSelect from "../../../components/ConditionSelect.vue";
import { getRequest } from "@/services/RequestService";
import Feedback from "./feedback.vue";
import { watch } from "vue";
import { error } from "jquery";
import moment from "moment";
import { data } from "jquery";

export default {
  components: {
    vSelect,
    ConditionSelect,
    TableComponent,
    Feedback
  },
  data() {
    return {
      isModalVisible: false,
      cancelModal: false,
      conditionOptions: [
        { label: "Tier", value: "Tier", disabled: false },
        { label: "Gender", value: "Gender", disabled: false },
        { label: "Age", value: "Age", disabled: false }
      ],
      feedbackModal: false,
      unformattedDate: null,
      unformattedTime: null,
      tableHeaders: [
        { name: "No." },
        { name: "RSVP" },
        { name: "IC Number" },
        { name: "Customer Name" },
        { name: "Mobile Number" }
      ],
      data: {
        type: 2,
        type_id: null,
        product_id: null,
        product: null,
        title: null,
        short_description: null,
        long_description: null,
        venue: null,
        date: null,
        unformattedDate: null,
        time: null,
        success_message: null,
        decline_message: null,
        quota: null,
        start_at: null,
        end_at: null,
        notification_time: null,
        image_upload: null,
        condition: [
          {
            field: null,
            value: null
          },
          {
            field: null,
            value: null
          }
        ]
      },
      filteredDate: new Date().toISOString().split("T")[0],
      summary: null,
      declined: null,
      rsvp: [],
      errors: {},
      rsvpLog: [],
      eventLog: [],
      productOptions: [],
      question: {
        id: null,
        my_activity_id: null,
        question: null,
        type_name: null,
        type: null,
        created_at: null
      },
      selectedType: null,
      type: null,
      questions: [],
      showModal: false,
      editQuestionModal: false,
      message: null,
      editOnly: false,
      feedbacksQuestion: [],
      call_requests: [],
      formDataTest: [],
      rsvp_decline: [],
      image_upload: null,
      cancelMessage: null,
      cancelErrorMessage: null,
      formattedStartDate: null,
      formattedEndDate: null,
      moreInfoLogs: [],
      processedRsvpDecline: [],
      isDisabled: false,
      tba_products: [],
      tbk_products: []
    };
  },

  computed: {
    start_at() {
      const date = new Date(this.data.start_at);
      return date.toISOString().split("T")[0];
    },
    end_at() {
      const date = new Date(this.data.end_at);
      return date.toISOString().split("T")[0];
    },
    date() {
      const date = new Date(this.data.date);
      const formattedDate = date.toISOString().split("T")[0];
      this.unformattedDate = "2018-07-28";
    },
    time() {
      const date = new Date(this.data.date);
      const formattedTime = date.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
      this.unformattedTime = formattedTime;
    },
    filteredEventLogData() {
      if (!this.filteredDate) return this.eventLog;
      return this.eventLog.filter(row => {
        const eventDate = row.event_update_date.split(" ")[0];
        return eventDate === this.filteredDate;
      });
    }
  },

  methods: {
    filterDate(e) {
      if (e.target.value) {
        this.filteredDate = e.target.value;
        this.fetchMoreInfo();
        this.fetchLog();
      } else {
        this.filteredDate = new Date().toISOString().split("T")[0];
        this.filteredData = this.eventLog.filter(
          item => item.date === this.filteredDate
        );
      }
    },

    async fetchData() {
      try {
        const response = await viewMyActivity(this.$route.params.id);
        if (response.data.success) {
          this.test_rsvp = response;
          this.data = response.data.data.my_activity;
          this.summary = response.data.data.summary;
          this.declined = response.data.data.declined;
          this.rsvp = response.data.data.rsvp;
          this.call_requests = response.data.data.call_requests;
          this.rsvp_decline = [
            ...this.declined,
            ...response.data.data.rsvp
          ].map(item => {
            const newItem = { ...item };
            if (item.declined_at === null) {
              newItem.type = "RSVP";
              newItem.date = item.rsvp_at;
            } else {
              newItem.type = "Declined";
              newItem.date = item.declined_at;
            }
            return newItem;
          });
        }
      } catch (error) {
        console.error(error);
      }
    },

    async fetchFeedback() {
      try {
        const response = await getFeedback(this.$route.params.id);
        if (response.data.success) {
          this.feedbacksQuestion = response.data.data;

          if (
            Array.isArray(response.data.data) &&
            response.data.data.length === 0
          ) {
            console.log("The data is an empty array.");
          } else if (response.data.data) {
            this.editOnly = true;
          }
        }
      } catch (error) {
        console.error("Error fetching feedback data: ", error);
      }
    },

    async fetchProduct() {
      let id;
      switch (this.data.type_id) {
        case 3:
          id = 1;
          break;
        case 4:
          id = 2;
          break;
        default:
          id = 1;
          break;
      }
      try {
        const response = await getRequest(`products/get-list`);

        if (response.data.success) {
          this.tba_products = response.data.data.tba;

          this.tbk_products = response.data.data.tbk.filter(
            product => ![7, 8].includes(product.id)
          );
        }
      } catch (e) {
        console.error(e);
      }
    },

    async fetchLog() {
      try {
        if ($.fn.DataTable.isDataTable("#event_log_tbl")) {
          $("#event_log_tbl")
            .DataTable()
            .destroy();
        }
        const response = await getLog(this.$route.params.id);

        if (response.data.success) {
          this.rsvpLog = response.data.data.rsvp_log;
          this.eventLog = response.data.data.event_log;
          this.$nextTick(() => {
            this.loadTable("#event_log_tbl");
          });
        }
      } catch (error) {
        console.error(error);
      }
    },

    async fetchMoreInfo() {
      try {
        if ($.fn.DataTable.isDataTable("#more_info_tbl")) {
          $("#more_info_tbl")
            .DataTable()
            .destroy();
        }
        const response = await getMoreInfo(this.$route.params.id, {
          date: this.filteredDate
        });
        if (response.data.success) {
          this.moreInfoLogs = response.data.data;
          this.$nextTick(() => {
            this.loadTable("#more_info_tbl");
          });
        }
      } catch (error) {
        console.error(error);
      }
    },

    handleType(e) {
      this.fetchProduct();
    },

    async handleFeedbackUpdate(id) {
      const req = { question: this.question.question };
      try {
        const response = await updateFeedback(id, req);

        if (response.data.success) {
          this.fetchFeedback();
        } else {
          console.log("Feedback update failed");
        }

        try {
          swal({
            title: response.data.success ? "Success" : "Failed",
            icon: response.data.success ? "success" : "error",
            text: response.data.message
          });
        } catch (swalError) {
          console.error("Swal error:", swalError);
        }

        this.editQuestionModal = false;
      } catch (error) {
        swal({
          title: "Error",
          icon: "error",
          text: "An error occurred while updating feedback."
        });
      }
    },

    formatStartEndDate(start, end) {
      if (start && end) {
        const startDate = new Date(start);
        const endDate = new Date(end);
        this.data.start_at = moment(startDate).format("YYYY-MM-DD");
        this.data.end_at = moment(endDate).format("YYYY-MM-DD");
      } else {
        console.error("Invalid start or end date provided");
      }
    },

    onConditionChange(value) {
      const { index, field } = value;
      this.data.conditions[index].field = field;
    },

    onValueChange(e) {
      const { index, value } = e;
      if (
        this.data &&
        this.data.conditions &&
        Array.isArray(this.data.conditions)
      ) {
        this.data.conditions[index].value = value;
      }
    },

    handleFileUpload(event) {
      const file = this.$refs.file.files[0];

      if (
        file &&
        file.size <= 5 * 1024 * 1024 &&
        file.type.startsWith("image/")
      ) {
        this.data.image_upload = file;
      } else {
        alert("Please upload a valid image file under 5MB.");
      }
    },

    clearError({ index, errorType }) {
      if (this.errors[errorType]) {
        delete this.errors[errorType];
      }
    },

    formatDateTime() {
      if (this.unformattedDate && this.unformattedTime) {
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        const timeRegex = /^\d{2}:\d{2}(:\d{2})?$/;

        if (
          dateRegex.test(this.unformattedDate) &&
          timeRegex.test(this.unformattedTime)
        ) {
          // Add seconds if missing
          const time =
            this.unformattedTime.includes(":") &&
              this.unformattedTime.length === 5
              ? `${this.unformattedTime}:00`
              : this.unformattedTime;

          return `${this.unformattedDate} ${time}`;
        }
      }

      return null;
    },

    formatDate(input) {
      const date = new Date(input);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    formatTime() {
      if (this.data.notification_time) {
        const today = new Date();
        const [hours, minutes] = this.data.notification_time.split(":");

        today.setHours(parseInt(hours), parseInt(minutes), 0, 0);

        const pad = num => String(num).padStart(2, "0");

        return `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(
          today.getDate()
        )} ${pad(today.getHours())}:${pad(today.getMinutes())}:${pad(
          today.getSeconds()
        )}`;
      }
      return null;
    },

    openModal() {
      this.isModalVisible = true;
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.modalInput) {
            this.$refs.modalInput.focus();
          }
        }, 0);
      });
    },

    openCancelModal() {
      this.cancelModal = true;
    },

    async handleCancel() {
      if (this.cancelMessage) {
        try {
          const response = await cancelMyActivity(this.$route.params.id, {
            remarks: this.cancelMessage
          });
          swal({
            title: response.data.success ? "Success" : "Failed",
            icon: response.data.success ? "success" : "error",
            text: response.data.message
          });

          this.cancelModal = false;
          this.fetchData();
        } catch (error) {
          console.error(error);
        }
      } else {
        this.cancelErrorMessage = "Message are required.";
      }
    },
    openFeedbackModal(feedback) {
      this.questions = feedback;
      this.feedbackModal = true;
    },

    openEditFeedbackModal(editData) {
      this.question = editData;
      this.editQuestionModal = true;
    },

    closeModal() {
      this.isModalVisible = false;
    },

    handleDisabled(disabled) {
      const firstConditionField = this.data.conditions[0].field;
      const secondConditionField = this.data.conditions[1].field;

      this.conditionOptions.forEach(option => {
        if (option.value === firstConditionField) {
          option.disabled = true;
        } else if (option.value === secondConditionField) {
          option.disabled = true;
        } else {
          option.disabled = false;
        }
      });
    },

    async handleSubmit() {
      await this.handleUpdate();
    },

    async handleFeedbackSubmit() {
      const request = { feedback_question: this.questions };
      try {
        const response = await storeFeedback(request);

        if (response.data.success) {
          this.feedbackModal = false;
          this.editOnly = true;
          this.fetchFeedback();
        }
        swal({
          title: response.data.success ? "Success" : "Failed",
          icon: response.data.success ? "success" : "error",
          text: response.data.message
        });
      } catch (error) {
        console.error(error);
      }
    },
    validateForm() {
      this.errors = {};

      const fields = [
        { name: "type", value: this.data.type, message: "Type is required." },
        {
          name: "title",
          value: this.data.title,
          message: "Title is required."
        },
        {
          name: "short_description",
          value: this.data.short_description,
          message: "Short description is required."
        },
        {
          name: "long_description",
          value: this.data.long_description,
          message: "Long description is required."
        },

        {
          name: "success_message",
          value: this.data.success_message,
          message: "Success message is required."
        },

        {
          name: "start_at",
          value: this.data.start_at,
          message: "Start time is required."
        },
        {
          name: "end_at",
          value: this.data.end_at,
          message: "End time is required."
        },
        {
          name: "notification_time",
          value: this.data.notification_time,
          message: "Notification time is required."
        },
        {
          name: "value1",
          value: this.data.conditions[0].value,
          message: "Condition 1 value is required."
        },
        {
          name: "field1",
          value: this.data.conditions[0].field,
          message: "Condition 1 field is required."
        },
        {
          name: "message",
          value: this.message,
          message: "message is required."
        }
      ];

      fields.forEach(field => {
        if (!field.value) {
          this.errors[field.name] = field.message;
        }
      });

      if (Array.isArray(this.data.conditions)) {
        const condition = this.data.conditions[0];

        if (!condition.field) {
          this.errors.field1 = "Condition 1 field is required.";
        }
        if (!condition.value) {
          this.errors.value1 = "Condition 1 value is required.";
        }

        if (
          this.data.conditions[0].field &&
          this.data.conditions[1] &&
          this.data.conditions[0].field === this.data.conditions[1].field
        ) {
          this.errors.field1 =
            "Condition 1 and Condition 2 cannot have the same field.";
          this.errors.field2 =
            "Condition 1 and Condition 2 cannot have the same field.";
        }
      } else {
        this.errors.condition = "Conditions are required.";
      }

      if (this.data.type === 2) {
        const fieldsToCheck = [
          {
            name: "decline_message",
            value: this.data.decline_message,
            message: "Decline message is required."
          },
          {
            name: "venue",
            value: this.data.venue,
            message: "Venue is required."
          },
          {
            name: "unformattedDate",
            value: this.data.unformattedDate,
            message: "Date is required."
          },
          {
            name: "time",
            value: this.data.time,
            message: "Time is required."
          },
          {
            name: "quota",
            value: this.data.quota,
            message: "Quota is required."
          }
        ];

        fieldsToCheck.forEach(field => {
          if (!field.value || field.value.trim() === "") {
            this.errors[field.name] = field.message;
          }
        });
      }

      if (this.data.start_at && this.data.end_at) {
        const startDate = new Date(this.data.start_at);
        const endDate = new Date(this.data.end_at);

        if (endDate <= startDate) {
          this.errors["start_end_date"] =
            "End date must be greater than the start date.";
        }
      }

      if (Object.keys(this.errors).length > 0) {
        return false;
      }

      return true;
    },

    async handleUpdate() {
      if (this.validateForm()) {
        const formData = new FormData();
        const validKeys = [
          "type",
          "title",
          "short_description",
          "long_description",
          "venue",
          "success_message",
          "decline_message",
          "reminder",
          "quota",
          "date",
          "start_at",
          "end_at",
          "notification_time",
          "product_id",
          "conditions",
          "image_upload"
        ];

        for (const key in this.data) {
          if (this.data[key] === null || this.data[key] === undefined) {
            continue;
          }

          if (validKeys.includes(key)) {
            if (key === "conditions" && Array.isArray(this.data.conditions)) {
              this.data.conditions.forEach((condition, index) => {
                formData.append(`condition[${index}][field]`, condition.field);
                formData.append(
                  `condition[${index}][my_activity_id]`,
                  Number(condition.my_activity_id)
                );
                formData.append(
                  `condition[${index}][id]`,
                  Number(condition.id)
                );
                formData.append(
                  `condition[${index}][value]`,
                  JSON.stringify(condition.value)
                );
              });
            } else if (key === "date") {
              formData.append(key, this.formatDateTime(this.data.date));
            } else if (key === "start_at" || key === "end_at") {
              formData.append(key, this.formatDate(this.data[key]));
            } else if (key === "notification_time") {
              formData.append(key, this.formatTime());
            } else if (key === "quota") {
              formData.append(key, Number(this.data[key]));
            } else if (
              key === "product_id" &&
              [3, 4].includes(this.data.type)
            ) {
              formData.append(key, Number(this.data.product.value));
            } else if (key === "product" && [3, 4].includes(this.data.type)) {
              formData.append(key, this.data.product.lable);
            } else if (key === "type") {
              formData.append("type", Number(this.data.type_id));
            } else if (key === "image_upload") {
              formData.append("image_upload", this.data.image_upload);
            } else {
              formData.append(key, this.data[key]);
            }
          }
        }
        formData.append("remarks", this.message);
        try {
          // formData.forEach((value, key) => {
          //   console.log(`${key}: ${value}`);
          // });
          // this.formDataTest = this.formDataToObject(formData);
          const response = await updateMyActivity(
            formData,
            this.$route.params.id
          );
          swal({
            title: response.data.success ? "Success" : "Failed",
            icon: response.data.success ? "success" : "error",
            text: response.data.message
          });
          if (response.data.success) {
            this.isModalVisible = false;
            swal({
              title: "Success",
              icon: "success",
              text: "Update successful!"
            });
            this.fetchData();
            this.fetchLog();
            this.fetchMoreInfo();
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        const errorMessages = Object.values(this.errors)
          .map(message => `• ${message}`) // Add bullet points
          .join("\n");
        swal({
          title: "Error",
          icon: "error",
          text: errorMessages
        });
      }
    },

    formDataToObject(formData) {
      const object = {};
      formData.forEach((value, key) => {
        if (object[key]) {
          if (Array.isArray(object[key])) {
            object[key].push(value);
          } else {
            object[key] = [object[key], value];
          }
        } else {
          object[key] = value;
        }
      });
      return object;
    },

    loadTable(id) {
      const table = $(id);
      if (table.length) {
        table.DataTable({
          pageLength: 5,
          dom: "Bfrtip",
          buttons: ["excel"],
          bDestroy: true
        });
      } else {
        console.warn(`Table with ID ${id} does not exist in the DOM.`);
      }
    },

    destroyDatatable(id) {
      $(id)
        .DataTable()
        .fnDestroy();
    },

    setDatatable() {
      this.loadTable("#rsvp_tbl");
      this.loadTable("#declined_tbl");
      this.loadTable("#tbk_tbl");
      this.loadTable("#tba_tbl");
      this.loadTable("#declined_tbl");
      this.loadTable("#declined_rsvp_tbl");
      this.loadTable("#event_log_tbl");
      this.loadTable("#more_info_tbl");
    },

    destroyDataTables() {
      this.destroyDataTable("#rsvp_tbl");
      this.destroyDataTable("#declined_tbl");
      this.destroyDataTable("#tbk_tbl");
      this.destroyDataTable("#tba_tbl");
      this.destroyDataTable("#declined_tbl");
      this.destroyDataTable("#declined_rsvp_tbl");
      this.destroyDatatable("#event_log_tbl");
      this.destroyDatatable("#more_info_tbl");
    },

    enable_disable() {
      $("#detail-form :input").prop("disabled", true);
      $("#detail-form select").prop("disabled", true);
      $("#detail-form textarea").prop("disabled", true);
      $("#detail-form input[type=file]").prop("disabled", true);
    },

    disableForm() {
      const inputs = this.$refs.detailForm.querySelectorAll(
        "input, select, textarea, button"
      );
      inputs.forEach(input => {
        input.disabled = true;
      });
    }
  },
  watch: {
    "data.date": function (newVal) {
      const date = new Date(newVal);
      this.unformattedDate = date.toISOString().split("T")[0];
      this.unformattedTime = date.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
    },
    "data.start_at": function (newVal) {
      this.formatStartEndDate(newVal, this.data.end_at);
    },
    "data.end_at": function (newVal) {
      this.formatStartEndDate(this.data.start_at, newVal);
    },
    "data.cancelled_at": function (newVal) {
      if (newVal) {
        this.isDisabled = true;
      }
    },
    "data.type_id": {
      handler: function (newVal) {
        this.fetchProduct();
      },
      immediate: true
    }
  },

  async mounted() {
    await this.fetchData();
    await this.fetchFeedback();
    await this.fetchProduct();
    await this.fetchLog();
    await this.fetchMoreInfo();
    this.processedRsvpDecline = this.rsvpLog.map(item => ({
      // index: item.index,
      rsvp_decline_date: item.description == 'RSVP' ? item.properties.attributes.rsvp_at : item.properties.attributes.declined_at,
      ic_number: item.causer.ic_number,
      customer_name: item.causer.name,
      mobile_number: item.causer.mobile_number,
      type: item.description
    }));
    this.$nextTick(() => {
      this.setDatatable();
    });
    this.formatStartEndDate(this.data.start_at, this.data.end_at);
  }
};
</script>

<style>
input[type="radio"] {
  accent-color: #ac8400;
}
</style>
